import {
    MDBAlert,
    MDBBtn, MDBInput,
    MDBModalBody,
    MDBModalFooter,
    MDBTextArea
} from "mdb-react-ui-kit";
import { useState } from "react";
import { sendPurchaseSMSPHnumreq } from "../../../apiclients/streamsapi_bridge";

export default function ReqSMSPhNums({ stateCode, areaCode, childClose, subChildClose }) {

    const [smsEnable, setSMSEnable] = useState(false);
    const [quantity, setQuantity] = useState("");
    const [remarks, setRemarks] = useState('');
    const [errors, setErrors] = useState({});
    const [failedErrorMessage, setFailedErrorMessage] = useState('');

    async function sendSMSPhNumPurchaseReq() {
     const newErrors = {};
    if (!quantity || isNaN(quantity) || quantity <= 0) {
        newErrors.quantity = "The quantity field must not be empty.";
    }
    if (!remarks.trim()) {
        newErrors.user_comments = "The remark field must not be empty.";
    }
    if (Object.keys(newErrors).length > 0) {
        setErrors(prev => ({ ...prev, ...newErrors }));
        return;
    }
        
        try {
            let apiResponse = await sendPurchaseSMSPHnumreq({
                reqid: 99,
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                quantity: quantity,
                area_code: parseInt(areaCode ?? 100),
                user_comments: remarks,
                is_sms_enabled: smsEnable,
                state_code: stateCode
            });
            let resdata = await apiResponse.json();
            if (apiResponse.status == 200) {
                localStorage.setItem("s_message", resdata.message);
                childClose();
                subChildClose();
                window.location.href = "/phonenumbers";
            } else if (apiResponse.status == 500) {
                setFailedErrorMessage("Internal Server Error");
            } else {
                let errorsJson = resdata.message.errors.reduce((obj, value) => {
                    obj[value.param_name] = value.message;
                    return obj
                }, {});
                console.log("errors  ::: " + JSON.stringify(errorsJson));
                setErrors(errorsJson);
                console.log("errors  :::::::::::::: " + JSON.stringify(errors));

                setFailedErrorMessage(errorsJson.area_code ?? errorsJson.state);
            }
        } catch (error) {
            console.log(`Unable to send sms enable request::${error}`)
            setFailedErrorMessage("Internal Server Error");
        }
    }
    return (
        <>
            <MDBModalBody>
                <div>
                    <div className="add-numbermain mt-0">
                        <div>
                            SMS Enabled
                        </div>
                        <div>
                            <label className="switch">
                                <input className="form-control" type="checkbox" onClick={(event) => setSMSEnable(!smsEnable)} />
                                <span className="slider round"></span>
                            </label>
                        </div>
                    </div>
                    {errors.is_sms_enabled && (
                        <p className="text-danger">{errors.is_sms_enabled}</p>
                    )}
                    <div className="add-numbermain">
                        <div>
                            Quantity
                        </div>
                        <div className="w-60">
                            <MDBInput placeholder="Enter Quantity"
                                onChange={(event) => {
                                    const val = event.target.value;

                                    if (val === '') {
                                        setQuantity('');
                                        setErrors(prev => ({
                                            ...prev,
                                            quantity: "The quantity field must not be empty."
                                        }));
                                    } else {
                                        setQuantity(parseInt(val));
                                        setErrors(prev => ({
                                            ...prev,
                                            quantity: null
                                        }));
                                    }
                                }}
                                onKeyDown={(event) => {
                                    if (!/[0-9]/.test(event.key) && event.key !== 'Backspace' && event.key !== 'Delete') {
                                        event.preventDefault();
                                    }
                                }} />
                            {errors.quantity && (
                                <p className="text-danger">{errors.quantity}</p>
                            )}
                        </div>
                    </div>

                    <div className="my-3">
                        {/* <p>
                            You have requested 5 Phone Numbers, but 0 Phone Number(s) are available, if you want to send a request for 5 phone numbers, you can click request button, otherwise click on cancel button.
                        </p> */}
                    </div>
                    <div>
                        Please Enter Remarks: (if any)
                    </div>
                    <MDBTextArea
                        required
                        value={remarks}
                        onChange={(event) => {
                            setRemarks(event.target.value);
                            if (errors.user_comments) {
                                setErrors(prev => ({ ...prev, user_comments: null }));
                            }
                        }}
                    />

                </div>
                {errors.user_comments && (
                        <p className="text-danger">{"The remark field must not be empty."}</p>
                    )}
                <MDBModalFooter className="mt-4">
                    <MDBBtn color='secondary' onClick={childClose}>
                        cancel
                    </MDBBtn>
                    <MDBBtn onClick={sendSMSPhNumPurchaseReq}>Request</MDBBtn>
                </MDBModalFooter>
            </MDBModalBody>


             {/* {failedErrorMessage !== "" && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={5000}
                    onClose={() => setFailedErrorMessage("")}
                >
                    {failedErrorMessage}
                </MDBAlert>
            )}  */}
        </>

    );

}